import { createRemoteJwkSet } from './jose/jwks/remote.ts';
import type { JwtVerifierOptions } from '../../types/jose/jwt';

type GetKeyFn = ReturnType<typeof createRemoteJwkSet>;

export type JwksOptions = Required<
    Pick<JwtVerifierOptions, 'timeout' | 'cacheMaxAge'>>
    & { fetch?: typeof fetch, URL?: typeof URL, crypto?: typeof crypto; }

export default (options: JwksOptions) => {
    const URLCtor = options.URL ?? URL;

    let getKeyFn: GetKeyFn;
    let prevJwksUri: string;

    return (jwksUri: string) => {
        if (getKeyFn === undefined || prevJwksUri !== jwksUri) {
            prevJwksUri = jwksUri;
            getKeyFn = createRemoteJwkSet(new URLCtor(jwksUri), options);
        }
        return getKeyFn;
    };
}
